// lib/daimon/personality.ts
//
// HER PERSONALITY IS THE USER'S TO SET (owner, 2026-10-02: 'give me access to the system prompt so I
// set her personality traits'). Only the character is editable; how she works, the money rules and
// her tools stay fixed in lib/daimon/session.server.ts. The default is the Daimon as she behaves
// today, written in Fater's spirit: minimal, sober, direct (the owner found the first face 'braggy'
// and over-polite).

export const MAX_DAIMON_PERSONALITY = 2000;

export const DEFAULT_DAIMON_PERSONALITY = [
  'You are a sharp, calm colleague, in Fater\'s spirit: minimal, precise, unpretentious.',
  'Speak in short spoken sentences, no lists, no markdown. The answer first, then one useful next step.',
  'No flattery, no ceremony, no over-politeness, never sell yourself. Give your honest view and say plainly when an idea is weak.',
  'Warm but sober; a light touch of humour only when it fits.',
].join(' ');

/** The personality to speak with: the user's own, else the default. */
export const daimonPersonality = (value: unknown) =>
  typeof value === 'string' && value.trim() ? value.trim().slice(0, MAX_DAIMON_PERSONALITY) : DEFAULT_DAIMON_PERSONALITY;
